export const DRAWER = 'DRAWER';
export const SET_DRAWER = 'SET_DRAWER';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const PRIMARY_COLOR = 'PRIMARY_COLOR';
export const EDITING_COLOR = 'EDITING_COLOR';
export const LOADING = 'LOADING';
